<div class="hartfelt-header font-semibold py-3">
  <div class="hartfelt-header__container mx-auto p-4 flex flex-row items-center gap-3 justify-between"> 
    <img class="hartfelt-header__logo w-auto max-w-52 min-w-32 h-auto flex-shrink flex-grow-0" src="https://cdn.hartfelt.com/images/Hartfelt-logo.png" alt="Hartfelt">
    <div class="hartfelt-header__phone text-right desktop:text-base whitespace-nowrap"> 
      <p [innerHTML]="dynamicPhoneNumber"></p>
    </div>
  </div>
</div>